import React from "react";
import ToggleSwitch from "./ToggleSwitch";

export default function Toggle({ checked, onChange, label, description, id }) {
  return (
    <div className="flex items-start gap-3">
      <ToggleSwitch
        id={id}
        checked={checked}
        onChange={onChange}
        ariaLabel={label}
      />
      <div>
        <label
          htmlFor={id}
          className="text-sm font-medium text-text-primary cursor-pointer"
        >
          {label}
        </label>
        {description && <p className="text-xs text-text-muted">{description}</p>}
      </div>
    </div>
  );
}
